import { SliceCaseReducers, createAction, createSlice } from '@reduxjs/toolkit';
import { BookingInterface, gunOptionsInterface } from '../types/types';
import { newStateFromFlatBooking } from '../components/utils/stateHelper';

export const setBookingStateFromFlat = createAction<BookingInterface>('setBookingStateFromFlat');

export const gunOptionSlice = createSlice<gunOptionsInterface, SliceCaseReducers<gunOptionsInterface>>({
    name: 'delivery',
    initialState: {
        "gunType": null,
        "quantity": null,
    },
    reducers: {
        changeGunOptions: (state, action) => {
            return {
                ...state,
                ...action.payload
            };
        },
    },
    extraReducers(builder) {
        builder.addCase(setBookingStateFromFlat, (state, action) => {
            const newState = newStateFromFlatBooking(state, action.payload);
            return newState as gunOptionsInterface;
        })
    },
});

export const { changeGunOptions } = gunOptionSlice.actions;
export default gunOptionSlice.reducer;